/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { TripPlan } from '../../../loco/shared/model/trip-plan.model';

/**
 * @export
 * @class LmsLocoTripPlanListComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-trip-plan-list',
  templateUrl: './lms-loco-trip-plan-list.component.html',
  styleUrls: ['./lms-loco-trip-plan-list.component.scss']
})
export class LmsLocoTripPlanListComponent implements OnInit, OnDestroy, OnChanges {

  @Input() listOfTripPlan: Array<TripPlan>;
  @Input() locoLabel: any;

  /**
   * Creates an instance of LmsLocoTripPlanListComponent.
   *
   * @memberOf LmsLocoTripPlanListComponent
   */
  constructor(private appUtilityService: AppUtilityService) {

  }

  /**
   * @memberOf LmsLocoTripPlanListComponent
   */
  ngOnInit() {
  }

  ngOnChanges() {
    if (this.listOfTripPlan) {
      for (let i = 0; i <= this.listOfTripPlan.length; i++) {
        if ((this.listOfTripPlan[i + 1] && (!this.appUtilityService.isValidTerminalId(this.listOfTripPlan[i + 1].tripTrainArrStation)) && !this.listOfTripPlan[i + 1].tripTrainArrDate)) {
          if ((this.listOfTripPlan[i] && this.listOfTripPlan[i + 1]) && (this.listOfTripPlan[i].tripTrainArrStation === this.listOfTripPlan[i + 1].tripTerminal
            && this.listOfTripPlan[i].tripTrainArrDate === this.listOfTripPlan[i + 1].tripDate
            && this.listOfTripPlan[i].tripCreateTS === this.listOfTripPlan[i + 1].tripCreateTS)) {
            this.listOfTripPlan[i + 1].isNextSame = true;
          }
        }
      }
    }
  }

  /**
   * @memberOf LmsLocoTripPlanListComponent
   */
  ngOnDestroy() {
  }

}
